package one.healthium.domain.common

enum class LoseWeightRange(
    val range: IntRange,
) {
    GetMoving(0..5),
    Realistic(6..9),
    HealthBenefits(10..20),
    WorthIt(21..38),
    LowWeightAlert(39..Int.MAX_VALUE);

    companion object {
        fun byRange(value: Int): LoseWeightRange? {
            return entries.firstOrNull { it.range.contains(value) }
        }
    }
}